module.exports = __webpack_public_path__ + "assets/img/0603.e337e21e.png";